export const formatNumber = (num) => {
  if (num === null || num === undefined) return '0.00';
  return Number(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const PAYMENT_METHODS = ['MoMo', 'Equity Bank', 'Bank of Kigali', 'Cash'];

export const ORDER_STATUSES = ['pending', 'processing', 'delivered', 'cancelled'];

export const getStatusColor = (status) => {
  switch(status) {
    case 'paid': return 'bg-green-100 text-green-800';
    case 'delivered': return 'bg-blue-100 text-blue-800';
    case 'processing': return 'bg-yellow-100 text-yellow-800';
    case 'partial': return 'bg-amber-100 text-amber-800';
    case 'cancelled': return 'bg-red-100 text-red-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};
